// PresalePriceContainer
import { ModalV3 } from "./Modal";
import { createSignal, Show } from "solid-js";
import { calculateDiscountedPrice, formatPrice } from "../js/utils";
import { createResource } from "solid-js";
import { InfoIcon } from "./InfoIcon";

export const PresalePriceContainer = (props) => {
  const showShippingPolicy = props.showShippingPolicy;
  const presale = props.productInfo.presale;
  const currentVariant = props.currentVariant; // signal
  const isDiscountApplied = props.isDiscountApplied; // signal
  const currencyConversion = props.currencyConversion;

  const price = () => {
    isDiscountApplied(); // used as an effect to rerun the price on isDiscountApplied state change

    const { price } = currentVariant();

    return formatPrice(price, currencyConversion);
  };

  const presalePrice = () => {
    const { price } = currentVariant();
    const discountValue = parseFloat(`${presale.discount_value}`)
    const discountType = presale.discount_type;
    if (isNaN(discountValue)) return null;

    const newPrice = calculateDiscountedPrice(price, discountValue, discountType); 

    return formatPrice(newPrice, currencyConversion);
  }

  const [presalePageTitle, setPresalePageTitle] = createSignal('');
  const [presaleInfoPage] = createResource(() => presale?.url, (url) => {
    if (url) {
      return fetch(url)
        .then(res => res.text())
        .then(text => {
          if (text == undefined) return null;

          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const section = doc?.querySelector('section.shopify-section');

          section?.querySelector('div.container')?.classList?.remove('mt-12')
          section?.querySelector('div.container')?.classList?.remove('md:px-10')
          section?.querySelector('div.container')?.classList?.remove('sm:px-5')
          section?.querySelector('div.container')?.classList?.remove('lg:my-10')
          section?.querySelector('div.container')?.classList?.add('mt-2')

          const title = section?.querySelector('article')?.querySelector('h1')?.innerText;
          setPresalePageTitle(title ?? '');
          section?.querySelector('article')?.querySelector('h1')?.classList.add('hidden');

          return section;
        });
    }
    return null;
  });

  const [modalState, setModalState] = createSignal(false);
  const handleModalOpenState = (state) => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = state ? 'hidden' : '';

    setModalState(state);
  }

  const presaleData = {
    ACTUAL_PRICE: `<span class="" >Regular Price: ${price()}</span>`,
    DISCOUNTED_PRICE: `<span class="py-1 font-semibold text-sale-700">Pre-order Price: ${presalePrice()}</span>`
  }

  return (
    <div class="my-2">
      <div class="bg-sale-600 flex font-bold gap-x-0.5 items-center mt-0.5 px-[6px] py-0.5 rounded-lg text-canvas text-center text-xs w-fit">
        <div class="text-2xs sm:text-xs">{presale?.pdp_badge_text}</div>
      </div>
      <div onClick={() => handleModalOpenState(true)} class="cursor-pointer flex hover:text-secondary-400 items-center mt-1 text-xs text-ink-link gap-0.5 text-left w-max"><InfoIcon /> {presale?.how_it_works_title}</div>
      <ModalV3
        title={presalePageTitle()}
        modalState={modalState()}
        handleModalOpenState={handleModalOpenState}
        modalClass={"sm:max-w-fit"}
      >
        {presaleInfoPage()}
      </ModalV3>

      <div
        class="font-mono text-base 2xl:text-lg mt-2 mb-1 ">
        <div class="gap-1 items-baseline text-sale-700 text-sm"
          innerHTML={presale.price_format.replace(/{{(.*?)}}/g, (_, key) => {
            return presaleData[key.trim()];
          })}
        />
        <Show when={showShippingPolicy}>
          <span class="text-2xs font-regular">(Inclusive of shipping & taxes)</span>
        </Show>
      </div>
    </div>
  )
}